import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SeparatorClass;
function Separator() {
  if (SeparatorClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.jb4_1.v('kiteui-separator');
      }
    }
    initMetadataForClass($, 'Separator');
    SeparatorClass = $;
  }
  return SeparatorClass;
}
//region block: exports
export {
  Separator as Separator36hc2oubnyjy3,
};
//endregion

//# sourceMappingURL=Separator.commonHtml.mjs.map
